import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import useSiteMetadata from "../../branding";

function BidaskHelmet({ pageDescription, lang, meta, pageTitle, location }) {
    const siteMetadata = useSiteMetadata();

    //use the siteMetadata values as default if there is nothing passed in
    const metaDescription = pageDescription || siteMetadata.description;
    const title = pageTitle || siteMetadata.title;

    const siteUrl = (siteMetadata.siteUrl || "").replace(/\/$/, ""); // no trailing slash

    // `location` is only automatically passed to Gatsby page components.
    // When this component is rendered elsewhere (or during SSR), `location` may be undefined.
    const pathname =
      location?.pathname ??
      (typeof window !== "undefined" ? window.location.pathname : "/");
  
    const canonicalPath = pathname === "/" ? "" : pathname.replace(/\/$/, "");
    const canonicalUrl = siteUrl ? `${siteUrl}${canonicalPath || "/"}` : undefined;

    const ogImage = siteUrl ? `${siteUrl}/og.jpg` : undefined;

    const links = [{ rel: `icon`, href: `/favicon-48x48.png`, type: `image/png` },{ rel: `icon`, href: `/favicon.ico` } ]
    if (canonicalUrl) links.push({ rel: `canonical`, href: canonicalUrl })

  // og tag best practices: https://ahrefs.com/blog/open-graph-meta-tags/
  return (
    <Helmet
      htmlAttributes={{lang,}}
      title={title}
      link={links}

      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        ...(canonicalUrl
          ? [
              {
                property: `og:url`,
                content: canonicalUrl,
              },
            ]
          : []),
        {
          property: `og:description`,
          content: metaDescription,
        },
        ...(ogImage
          ? [
              {
                property: `og:image`,
                content: ogImage,
              },
            ]
          : []),
        {
          property: `og:type`,
          content: `website`,
        },
      ].concat(meta)}
    />
  )
}

BidaskHelmet.defaultProps = {
  lang: `en`,
  meta: [],
  pageDescription: ``,
}

BidaskHelmet.propTypes = {
  pageDescription: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  pageTitle: PropTypes.string.isRequired,
}

export default BidaskHelmet;
